import { NumericFormat } from 'react-number-format';
import { classNames } from 'primereact/utils';
import WithController from '../with-controller';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';

interface InputNumberProps {
  placeholder?: string;
  disabled?: boolean;
  maxFractionDigits?: number;
  className?: string;
}

const InputNumber = WithController<PropTypes, number>(
  ({
    field,
    fieldState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    formState: _formState,
    triggerDependencies,
    visible = true,
    maxFractionDigits = 20,
    className,
    ...props
  }) => (
    <InputEnhancements
      addonRight={addonRight}
      addonLeft={addonLeft}
      label={label}
      withErrorMessage={withErrorMessage}
      containerClassName={containerClassName}
      field={field}
      fieldState={fieldState}
      visible={visible}
    >
      <NumericFormat
        {...props}
        id={field.name}
        name={field.name}
        getInputRef={field.ref}
        value={field.value ?? ''}
        onBlur={field.onBlur}
        onValueChange={(values) => {
          field.onChange(values.floatValue ?? null);
          triggerDependencies();
        }}
        decimalScale={maxFractionDigits}
        decimalSeparator=","
        className={classNames(
          'p-inputtext p-component',
          { 'p-invalid': fieldState.error },
          className,
        )}
      />
    </InputEnhancements>
  ),
);

type OmittedProps =
  | 'id'
  | 'name'
  | 'getInputRef'
  | 'value'
  | 'onBlur'
  | 'onValueChange';

type PropTypes = Omit<InputNumberProps, OmittedProps> & FormInputEnhancements;

export default InputNumber;
